/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

class FitinsurAPI {
  constructor(props) {
    this.username = String("");
    this.fit_auth_status = Boolean(false);
    this.fit_auth_token = null;
    this.baseurl = String(process.env.REACT_APP_FITINSUR_STAGING_API_URL);

    this.sampleUsername = "";
    this.samplePassword = "";

    this.questionDomain = {
      TEXT: 42,
      LIST: 43,
      VALUE: 44,
      ATTACHMENT: 270,
      ATTACHMENT_MULTI: 271,
      SEARCH: 276,
      DATE: 277,
    };

    this.personDomain = {
      FISICA: 34,
      JURIDICA: 35,
    };

    this.personContractor = {
      idPerson: null,
      firstName: null,
      lastName: null,
      legalId: null,
    };

    this.personCustomer = {
      idPerson: null,
      firstName: null,
      lastName: null,
      legalId: null,
    };

    this.personBroker = {
      idPerson: null,
      firstName: null,
      lastName: null,
      legalId: null,
    };

    this.DOMAIN_PERSON_ROLE = {
      CONTRACTOR: 3,
      CUSTOMER: 4,
      BROKER: 10,
    };

    this.responseValidation = {
      ADD2_LENGTH: 10,
    };
  }

  // ==========================================================================================
  // FITINSUR METHODS
  // ==========================================================================================
  getSampleUsername() {
    return this.sampleUsername;
  }

  getSamplePassword() {
    return this.samplePassword;
  }

  async requestLoginSync() {
    this.requestName = "/login";

    this.username = this.sampleUsername;
    let bodyData = {
      username: this.username,
      password: this.samplePassword,
    };

    let response = {};
    try {
      response = await fetch(this.baseurl + this.requestName, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });
    } catch (error) {
      throw new Error(
        `HTTP fetch error: ${error.message} - ${response.status} - ${response.statusText}`
      );
    }

    let data = {};
    try {
      data = await response.json();
    } catch (error) {
      throw new Error(`Response json error: ${error.message}`);
    }

    if (String(data.ret_code) === String(200)) {
      this.fit_auth_status = true;
      this.fit_auth_token = data.ret_token;
    } else {
      this.fit_auth_status = false;
      this.fit_auth_token = "";
    }

    return Boolean(true);
  }

  requestLoginLegacy(username, password) {
    this.requestName = "/login";

    let bodyData = {
      username: username && username !== "" ? username : this.sampleUsername,
      password: password && password !== "" ? password : this.samplePassword,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      null
    );
  }

  requestLogin(username, password, application) {
    this.requestName = "/login/v2";

    let bodyData = {
      action: "login",
      username: username && username !== "" ? username : this.sampleUsername,
      password: password && password !== "" ? password : this.samplePassword,
      application,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      null
    );
  }

  requestFileUpload(files) {
    this.requestName = `/file`;

    const options = {
      method: "POST",
      body: files,
      headers: {
        Authorization: "Token " + this.fit_auth_token,
        "fit-auth-token": this.fit_auth_token,
      },
    };
    return fetch(this.baseurl + this.requestName, options);
  }

  requestFileUploadS3(files) {
    this.requestName = `/file/s3`;

    const options = {
      method: 'POST',
      body: files,
      headers: {
        'Authorization': ('Token ' + this.fit_auth_token),
        'fit-auth-token': this.fit_auth_token,
      }
    };
    return fetch(this.baseurl + this.requestName, options);
  };


  requestBrokerList() {
    this.requestName = "/query";

    let bodyData = {
      id: "fitGetBrokerList",
      params: {},
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestLostDealList(idQuestion) {
    this.requestName = "/query";

    let bodyData = {
      id: "fitGetLostReason",
      params: { idQuestion }
    };

    return this.httpRequestPost(this.baseurl + this.requestName, bodyData, this.fit_auth_token);
  }

  requestForgotPassword(username, application) {
    this.requestName = "/login/v2";

    let bodyData = {
      action: "forgotpw",
      username: username,
      password: "",
      application
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestChangePassword(username, password, newPassword) {
    this.requestName = "/login/v2";

    let bodyData = {
      action: "changepw",
      username: username,
      password: password,
      newPassword: newPassword,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestAccess(
    username,
    dsDomPrivilege,
    idDomain,
    idPersonRelation,
    idOperation,
    token
  ) {
    this.requestName = "/access";

    let bodyData = {
      username: username,
      dsDomPrivilege: dsDomPrivilege,
      idDomain: idDomain,
      idPersonRelation: idPersonRelation,
      idOperation: idOperation,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token ? this.fit_auth_token : token
    );
  }

  requestListAction(queryParams) {
    this.requestName = "/quote/list/v2" + queryParams;
    const bodyData = null;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestBrokerHeader() {
    this.requestName = "/quote/brokers";

    const bodyData = null;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestStatusHeader() {
    this.requestName = "/quote/status-operations";
    const bodyData = null;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestAddAction(id_product, id_product_list) {
    this.requestName = "/quote/add";

    const bodyData = {
      id_product: id_product,
      id_product_list: id_product_list,
      add_step: 1,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  createMASQuestionnaire(idOperation, questionnaire, files) {
    this.requestName = `/quote/mas/questionnaire`;
    let bodyData = {
      idOperation,
      questionnaire,
      files
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestAddAction2(params) {
    console.log("FitinsurAPI.requestAddAction2 - BEGIN");

    this.requestName = "/quote/add";

    const bodyData = {
      add_step: 2,
      idOperation: params.idOperation,
      id_person: params.id_person,
      id_product: params.id_product,
      id_product_list: params.id_product_list,
      idPlanCoverage: params.idPlanCoverage,
      OptionMaxLim: params.OptionMaxLim,
      OptionDeduct: params.OptionDeduct,
      paymentMode: params.paymentMode,
      paymentMethod: params.paymentMethod,
      firstInstallmentDate: params.firstInstallmentDate,
      coverageListSelected: params.coverageListSelected,
      riskQuestionnaireId: params.riskQuestionnaireId,
      personQuestionnaire: params.personQuestionnaire,
      operationQuestionnaire: params.operationQuestionnaire,
      riskQuestionnaire: params.riskQuestionnaire,
      idDomainPerson: params.idDomainPerson, // ToDo pegar dinamico
      idRiskAnswer: [],
      idRiskQuestion: [],
      legalPersonId: null,
      paymentQuestionnaire: [],
      personFirstName: params.personFirstName, // ToDo pegar dinamico
      personLastName: params.personLastName, // ToDo pegar dinamico
      riskIdQuestionnaire: null,
      textRiskAnswer: [],
      isConfirmation: params.isConfirmation,
      sendQuoteRequest: params.sendQuoteRequest,
      updateQuestionnaire: params.updateQuestionnaire
    };

    console.log("FitinsurAPI.requestAddAction2 - END");

    return this.httpRequestPost(this.baseurl + this.requestName, bodyData, this.fit_auth_token);
  }

  requestIssueAction(idOperation, body = {}) {
    this.requestName = "/issue/v2";

    let bodyData = {
      idOperation: idOperation,
      ...body
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestQueryAction(id, params) {
    this.requestName = "/query";

    const bodyData = {
      id: id,
      params: params,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  async requestQueryAction2(id, params) {
    this.requestName = "/query";

    const bodyData = {
      id: id,
      params: params,
    };

    let result;
    try {
      let resultHttp = await this.httpRequestPost(
        this.baseurl + this.requestName,
        bodyData,
        this.fit_auth_token
      );
      result = await resultHttp.json();
    } catch (err) {
      result = "requestQueryAction2 - ERROR: " + err.message;
    }

    return result;
  }
  getLoginStatus() {
    return Boolean(this.fit_auth_status) === Boolean(true)
      ? "Usuario autenticado: " + this.username
      : "Usuario nao autenticado";
  }

  getPendingOperations() {
    this.requestName = "/quote/pendent-approval";
    const bodyData = null;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSerproCnpj(cnpj) {
    this.requestName = "/serpro/cnpj?id=" + cnpj;

    const bodyData = null;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestQuoteAdd(productId, idDomain, idDomainStatus) {
    const queryParams = (idDomain || idDomainStatus) ? `?idDomain=${idDomain || ''}&idDomainStatus=${idDomainStatus || ''}` : ''
    this.requestName = "/quote/add/list/" + productId + queryParams;

    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestEditDocuments(idOperation) {
    this.requestName = "/quote/attachments/v3/" + idOperation;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  updateQuoteEdit(idOperation, idAnswerOption, idQuestion) {
    console.log("FitinsurAPI.updateQuoteEdit - BEGIN");
    this.requestName = `/quote/status/lose/v3/${idOperation}/${idAnswerOption}/${idQuestion}`;
    console.log("FitinsurAPI.updateQuoteEdit - END");

    return this.httpRequestPut(this.baseurl + this.requestName, null, this.fit_auth_token);
  };

  updateAttachmentOperation(body) {
    this.requestName = "/quote/add/attachments/v3";

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  saveQuestionsPayments(idOperation, questionnaire, coverageOptionSelected, isDraft = false) {
    this.requestName = `/payments/save-questions-payments/${idOperation}`;
    let bodyData = {
      questionnaire,
      coverageOptionSelected,
      isDraft
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  changeBrokerList(body) {
    this.requestName = "/quote/broker";

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestPersonList(id, params) {
    this.requestName = "/query";
    let bodyData = {
      id: id,
      params,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestQuoteSubmit(body) {
    this.requestName = "/quote/add/create/v3";
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestProductsList(body) {
    this.requestName = "/query";

    let bodyData = {
      id: "fitGetProductPerson",
      params: {},
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestQuoteEdit(productId, idOperation) {
    this.requestName = `/quote/edit/list/${productId}/${idOperation}`;

    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestGetQuotePlans(idOperation, onlyQuotation) {
    console.log("GET FitinsurAPI.requestGetQuotePlans - BEGIN");

    this.requestName = `/nbi/v2/create-option/${idOperation}?${onlyQuotation ? "onlyQuotation=true" : ""}`;

    console.log("GET FitinsurAPI.requestGetQuotePlans - END");

    return this.httpRequestGet(this.baseurl + this.requestName, null, this.fit_auth_token);
  }

  requestSaveQuotePlans(idOperation, calculation, questionnaire, rootQuestionnaire) {
    console.log("GET FitinsurAPI.requestGetQuotePlans - BEGIN");

    this.requestName = `/nbi/v2/save-option/${idOperation}`;

    console.log("GET FitinsurAPI.requestGetQuotePlans - END");

    return this.httpRequestPost(this.baseurl + this.requestName, { calculation, questionnaire, rootQuestionnaire }, this.fit_auth_token);
  }

  requestUpdateCoverageList(idOperation, calculation, proceed) {
    console.log("GET FitinsurAPI.requestUpdateCoverageList - BEGIN");

    this.requestName = `/nbi/v2/update-coverage-list/${idOperation}`;

    console.log("GET FitinsurAPI.requestUpdateCoverageList - END");

    return this.httpRequestPost(this.baseurl + this.requestName, { calculation, proceed }, this.fit_auth_token);
  }


  recalculateCoverage(idOperation, idProduct, idProductCoverage, isCoefficient, lmi, idProductPlan) {
    console.log("GET FitinsurAPI.recalculateCoverage - BEGIN");

    this.requestName = `/operation/v2/coverage-calc-item/${idOperation}`;

    const body = {
      idProduct,
      idProductCoverage,
      idProductPlan,
      questionMappingAdhoc: [
        {
          mapName: "mapQuestion470",
          mapValue: isCoefficient
        },
        {
          mapName: "mapQuestion434",
          mapValue: lmi
        }
      ]
    }

    console.log("GET FitinsurAPI.recalculateCoverage - END");

    return this.httpRequestPost(this.baseurl + this.requestName, body, this.fit_auth_token);
  }

  recalculateCoverageByComission(idOperation, idProduct, idProductPlan, customCommission, getCoverageCalculation, productCoverageList ) {
    console.log("GET FitinsurAPI.recalculateCoverage - BEGIN");

    this.requestName = `/operation/v2/coverage-calc-item/${idOperation}`;

    const body = {
      idProduct,
      idProductPlan,
      customCommission,
      getCoverageCalculation,
      productCoverageList,
    }

    console.log("GET FitinsurAPI.recalculateCoverage - END");

    return this.httpRequestPost(this.baseurl + this.requestName, body, this.fit_auth_token);
  }


  requestGetCreateQuotePlans(idOperation, maxChildren = 3) {
    console.log("GET FitinsurAPI.requestGetQuotePlans - BEGIN");

    this.requestName = `/nbi/v2/create-option`;

    console.log("GET FitinsurAPI.requestGetQuotePlans - END");

    return this.httpRequestPost(this.baseurl + this.requestName, { idOperation, maxChildren }, this.fit_auth_token);
  }

  requestSaveExtraModality(idOperation, questionnaire) {
    console.log("POST FitinsurAPI.requestSaveExtraModality - BEGIN");

    this.requestName = `/nbi/v2/create-sub-option/${idOperation}`;

    console.log("POST FitinsurAPI.requestSaveExtraModality - END");

    return this.httpRequestPost(this.baseurl + this.requestName, { questionnaire }, this.fit_auth_token);
  }

  requestDeleteQuotePlans(idOperation) {
    console.log("POST FitinsurAPI.requestSaveExtraModality - BEGIN");

    this.requestName = `/nbi/v2/remove-option/${idOperation}`;

    console.log("POST FitinsurAPI.requestSaveExtraModality - END");

    return this.httpRequestDelete(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }

  requestGenerateQuotePlanDocument(idOperation) {
    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - BEGIN");
    this.requestName = `/nbi/v2/generate-report/${idOperation}`;

    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - END");

    return this.httpRequestPost(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }

  requestGetQuotePlanDocument(idOperation) {
    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - BEGIN");
    this.requestName = `/nbi/v2/report/${idOperation}`;

    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - END");

    return this.httpRequestGet(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }

  requestGenerateOrderDocument(idOperation, data) {
    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - BEGIN");
    this.requestName = `/nbi/v2/generate-order/${idOperation}`;

    const body = { ...data }

    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - END");

    return this.httpRequestPost(this.baseurl + this.requestName, body, this.fit_auth_token);
  }

  requestNBIRequestLawyer(idOperation) {
    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - BEGIN");
    this.requestName = `/quote/send-email-lawyer/${idOperation}`;

    console.log("POST FitinsurAPI.requestGenerateQuotePlanDocument - END");

    return this.httpRequestPost(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }

  requestGetQuote(productId, idOperation, onlyQuestions = false, idDomainStatus) {
    console.log("GET FitinsurAPI.requestGetQuoteAction - BEGIN");

    this.requestName = `/quote/edit/list/${productId}/${idOperation}?${idDomainStatus ? `idDomainStatus=${idDomainStatus}&` : ""}${onlyQuestions ? "onlyQuestions=true" : ""}`;

    console.log("GET FitinsurAPI.requestGetQuoteAction - END");

    return this.httpRequestGet(this.baseurl + this.requestName, null, this.fit_auth_token);
  }

  requestQuoteEditNavigation(idOperation) {
    this.requestName = `/quote/edit/navigation/v3/${idOperation}`;

    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestQuoteApprove(body) {
    this.requestName = `/quote/status/aprove/v3`;

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }
  requestQuoteReject(body) {
    this.requestName = `/quote/status/reject/v3`;

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  //////////// PERSON //////////////////////
  requestGetAddressByZipCode(zipCode) {
    this.requestName = `/correios/dne/${zipCode}`;
    return this.httpRequestGet(this.baseurl + this.requestName, {}, this.fit_auth_token);
  };

  requestPerson(idPerson) {
    this.requestName = `/person/info/${idPerson}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestPersonCombobox() {
    this.requestName = `/person/listOptions`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSavePerson(body) {
    this.requestName = `/person`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestListContacts(idPerson) {
    this.requestName = `/person/list-contacts/${idPerson}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestListEnquiries(idPerson) {
    this.requestName = `/person/list-enquiries/${idPerson}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  exportQuotes(queryString) {
    this.requestName = `/report/quotes/xlsx${queryString}`;
    let body = {};
    return this.httpRequestGet(this.baseurl + this.requestName, body, this.fit_auth_token);
  };

  requestGetDocumentIdMetadata(idDocument) {
    this.requestName = `/document/document-id-metadata/${idDocument}`;
    const body = {};
    return this.httpRequestGet(this.baseurl + this.requestName, body, this.fit_auth_token);
  }

  requestPutDocumentUpdateMetadata(idDocument) {
    this.requestName = `/document/document-update-metadata/${idDocument}`;
    const body = {};
    return this.httpRequestPut(this.baseurl + this.requestName, body, this.fit_auth_token);
  }

  disableUser(idPerson) {
    this.requestName = `/person/v2/${idPerson}`;

    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  //////////// POLICY PACK //////////////////////
  createPolicyPack(idOperation) {
    this.requestName = `/quote/policy/create/${idOperation}`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  enablePolicySend(idOperation) {
    this.requestName = `/quote/wording/enable/policy/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestPolicyDocument(idOperation, renderWelcomekit) {
    if (renderWelcomekit) {
      this.requestName = `/quote/policy/${idOperation}?renderWelcomekit=1`;
    } else {
      this.requestName = `/quote/policy/${idOperation}`;
    }
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  sendPolicyPack(body) {
    this.requestName = "/quote/policy/sent-policy-pack";
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  policyPackSendDirectorApproval(
    idOperation,
    policyPackDirectorApprovalMessage
  ) {
    this.requestName = `/quote/policy/director-approval/send`;
    let bodyData = {
      idOperation: idOperation,
      policyPackDirectorApprovalMessage: policyPackDirectorApprovalMessage,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  policyPackSendDirector(body) {
    this.requestName = `/quote/policy/send-director`;
    let bodyData = body;

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  policyPackListDirectors(idOperation) {
    this.requestName = `/quote/policy/director-approval/list-directors/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  policyPackApprove(idOperation, userComments) {
    this.requestName = `/quote/policy/director-approval/approve`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  policyPackReject(idOperation, userComments) {
    this.requestName = `/quote/policy/director-approval/reject`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestPolicyPack(idOperation) {
    this.requestName = `/quote/policy/approvals/list/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestAttachAssumptions(idOperation) {
    this.requestName = `/quote/schedulle/attachment-assumptions/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  ////////////// Requests Edit //////////////////

  requestEnableNbiForm(id) {
    this.requestName = `/quote/enable-nbi-form/${id}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  getMessage(uid, isoCode, idDomain) {
    this.requestName = `/textmessage?messageAlias=${uid}&messageIsoCode=${isoCode}&idDomain=${idDomain}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestSendNbiForm(idOperation, idTemplate) {
    this.requestName = "/quote/send-nbi-form";
    let bodyData = {
      idTemplate: idTemplate,
      idOperation: idOperation,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSicCode(id) {
    this.requestName = `/quote/sic-code/${id}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  //////////// mask config ////////////

  requestConfig(idFields, idDomain = null) {
    this.requestName = "/quote/question/configuration";
    let bodyData = {
      idFields: idFields,
      idDomain: idDomain,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests NBI Request ///////////////

  requestFileList(id) {
    this.requestName = "/quote/nbi-form";
    let bodyData = {
      idTemplate: 4,
      idOperation: id,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestHeaderNbi(id) {
    this.requestName = "/quote/header-nbi-request";
    let bodyData = {
      idOperation: id,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestAproveNbiForm(id, message, nbiSubject) {
    this.requestName = "/quote/aprove-nbi-form";
    let bodyData = {
      idOperation: id,
      nbiSubjectMessage: message,
      nbiSubject,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests NBI Request CV ///////////////

  requestClientForm(id, insurers) {
    this.requestName = "/quote/nbi-client-form";
    let bodyData = {
      idOperation: id,
      insurers: insurers,
      updateMarketes: true,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests NBI Aproves ///////////////

  requestDocument(id, idTemplate = 4) {
    this.requestName = "/quote/document";
    let bodyData = {
      idTemplate: idTemplate,
      idOperation: id,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestRejectNbiReq(id, answer) {
    this.requestName = "/quote/reject-nbi-request";
    let bodyData = {
      idOperation: id,
      txtAnswerOption: answer,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestAproveNbiReq(id, answer) {
    this.requestName = "/quote/approve-nbi-request";
    let bodyData = {
      idOperation: id,
      txtAnswerOption: answer,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSendApprove(body) {
    const {
      idOperation,
      nbiClientSubjectMessage,
      additionalNbiClientSubjectivity,
    } = body;

    this.requestName = "/quote/send-approval-nbi-client";
    let bodyData = {
      idOperation: idOperation,
      nbiClientSubjectMessage: nbiClientSubjectMessage,
      additionalNbiClientSubjectivity: additionalNbiClientSubjectivity,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestIdDocument(id) {
    this.requestName = `/quote/nbi-document/${id}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests Select Markets ///////////////

  requestListMarkets(idOperation) {
    this.requestName = `/quote/list-market/${idOperation}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSelectMarkets(idOperation, selectedItems, isMasterPolicy = false) {
    this.requestName = "/quote/select-market";
    let bodyData = {
      idsInsurersSelected: selectedItems,
      reviewApproved: 1,
      idOperation: idOperation,
      isMasterPolicy,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestInsurerValues(idOperation) {
    this.requestName = `/quote/rate/insurers-calcs/${idOperation}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestInsurerLock(body) {
    this.requestName = `/quote/rate/insurers`;

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestInsurerTotals(idOperation) {
    this.requestName = `/quote/schedulle/postedInsuerValues/${idOperation}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  generateExceXLS(body) {
    this.requestName = "/quote/schedulle/initial-export";
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestImportExcel(formData) {
    this.requestName = "/quote/schedule/import";
    const options = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Token " + this.fit_auth_token,
        "fit-auth-token": this.fit_auth_token,
      },
    };
    return fetch(this.baseurl + this.requestName, options);
  }

  requestScheduleStatus(idOperation) {
    this.requestName = `/quote/schedulle/status/${idOperation}`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSchedulleAssumptionsUpload(formData) {
    this.requestName = `/quote/schedulle/upload-assumptions`;

    const options = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Token " + this.fit_auth_token,
        "fit-auth-token": this.fit_auth_token,
      },
    };
    return fetch(this.baseurl + this.requestName, options);
  }

  requestGetSchedulleAssumptions(idOperation) {
    this.requestName = `/quote/schedulle/attachment-assumptions/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestDeleteSchedulleAssumptions(idOperation, idDocument) {
    this.requestName = `/quote/attachments/v3`;
    let body = {
      idOperation: idOperation,
      idDocument: idDocument,
    };
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  submitSchedulleConfirm(idOperation) {
    this.requestName = "/quote/schedulle/confirm";
    let body = { idOperation: idOperation };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestImportStatus(idOperation) {
    this.requestName = `/quote/schedulle/import/status/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestLoseMarket(idOperation, idAnswerOption) {
    this.requestName = `/quote/status/lose/v3/${idOperation}/${idAnswerOption}`;
    let bodyData = {};

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ////////////// Re-send NBI REQUEST ////////////////
  prepareNbiForm(idOperation, idPersonInsurer) {
    this.requestName = "/quote/prepare-nbi-form-resent";
    let bodyData = {
      idOperation: idOperation,
      idPersonInsurer: idPersonInsurer,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }
  reSendNbiForm(idOperation, idPersonInsurer) {
    this.requestName = "/quote/resent-nbi-form";
    let bodyData = {
      idOperation: idOperation,
      idPersonInsurer: idPersonInsurer,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  marketSelectionUpdateManually(idOperation, idPersonInsurer) {
    this.requestName = "/quote/nbi-client-form-broker";
    let bodyData = {
      idOperation: idOperation,
      idPersonInsurer: idPersonInsurer,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  /////////////       Drawer       //////////////////

  sidedrawerRemember() {
    this.requestName = `/sidedrawer/remember/`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Market Composition //////////////////

  requestGenerateWording(idOperation) {
    this.requestName = `/quote/wording/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Send NBI ///////////////

  listClientContacts(idOperation) {
    this.requestName = `/quote/list-client-contacts/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSentEmailClient(body) {
    this.requestName = "/quote/sent-email-client";

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  listDirectorsContacts(idOperation) {
    this.requestName = `/quote/list-directors-contacts/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests List Contact ///////////////

  requestListContact(idOperation) {
    this.requestName = `/quote/list-contact/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestListContactsByType(idOperation, type, idContactDepartment) {
    this.requestName = idContactDepartment
      ? `/quote/${type}/list-contacts/${idOperation}?idContactDepartment=${idContactDepartment}`
      : `/quote/${type}/list-contacts/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestConfirmContacts(idOperation, insurers) {
    this.requestName = "/quote/confirm-contacts";
    let bodyData = {
      idOperation: idOperation,
      insurers: insurers,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests Send NBI Request ///////////////

  requestNbReqDocument(idOperation) {
    this.requestName = `/quote/nb-req-document/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSendNbiRequest(idOperation, CC, BCC) {
    this.requestName = "/quote/send-contacts-nbi-request";
    let bodyData = {
      idOperation: idOperation,
      cc: CC,
      bcc: BCC,
    };

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests MARKETS SELECTION ///////////////

  requestMarketsResponse(idOperation) {
    this.requestName = `/quote/markets-reponse/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests Schedule Exibition ///////////////

  requestScheduleReport(idOperation) {
    this.requestName = `/quote/schedulle/report/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  processingPeriodsSchedule(idOperation, getLastImport) {
    this.requestName = `/quote/schedulle/processing-periods/${idOperation}`;

    if (getLastImport)
      this.requestName = `/quote/schedulle/processing-periods/${idOperation}?getLastImport=${true}`;

    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Wording approvals ///////////////

  wordingSendApproval(idOperation, policyPackMessage, effectiveDate) {
    this.requestName = `/quote/policy/send-approval`;
    let bodyData = {
      idOperation: idOperation,
      policyPackMessage: policyPackMessage,
      effectiveDate: effectiveDate,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  wordingHtmlModal(idOperation) {
    this.requestName = `/quote/policy/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  wordingAttachments(idOperation) {
    this.requestName = `/quote/wording/enable/policy/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  wordingBrokerSrApprove(idOperation, userComments) {
    this.requestName = `/quote/status/aprove/v3`;
    let body = {
      idOperation: idOperation,
      txtAnswerOption: userComments,
    };
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  wordingBrokerSrReject(idOperation, userComments) {
    this.requestName = `/quote/status/reject/v3`;
    let body = {
      idOperation: idOperation,
      txtAnswerOption: userComments,
    };
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// Requests Generate WORDING //////////////////

  requestWordingModal(idOperation) {
    this.requestName = `/quote/wording/modal/show/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetEditWordingUrl(idOperation) {
    this.requestName = `/quote/wording/report/access/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetEnablePolicy(idOperation) {
    this.requestName = `/quote/wording/enable/policy/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestWordingUpload(formData) {
    this.requestName = `/quote/wording/uploadV2`;

    const options = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Token " + this.fit_auth_token,
        "fit-auth-token": this.fit_auth_token,
      },
    };
    return fetch(this.baseurl + this.requestName, options);
  }

  requestGetDocuments(idOperation, isDefaultAttachment = false) {
    this.requestName = `/quote/wording/attachments/${idOperation}${isDefaultAttachment ? "?isDefaultAttachment=true" : ""
      }`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestGetSignedDocuments(idOperation, isDefaultAttachment = false) {
    this.requestName = `/quote/list-signed-documents/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestGetAttachment(idOperation, idPerson) {
    this.requestName = `/quote/approval/attachments/${idOperation}/${idPerson}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestWordingDelAttach(idOperation, idDocument) {
    this.requestName = `/quote/attachments/v3`;
    let body = {
      idOperation: idOperation,
      idDocument: idDocument,
    };
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestWordingDelete(idOperation, idDocument) {
    this.requestName = `/quote/wording/attachments/${idOperation}/${idDocument}`;
    let body = {
      idOperation: idOperation,
      idDocument: idDocument,
    };
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// MRC /////////////////////

  requestMrcComplementary(idOperation) {
    this.requestName = "/quote/mrc/complementary/" + idOperation;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  saveMrcComplementary(idOperation, bodyData) {
    this.requestName = "/quote/mrc/complementary/save/" + idOperation;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  saveMrcPart1(idOperation, bodyData) {
    this.requestName = "/quote/mrc/part1/save/" + idOperation;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  saveMrcPart2(idOperation, bodyData) {
    this.requestName = "/quote/mrc/part2/save/" + idOperation;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestMRCModal(idOperation) {
    this.requestName = `/quote/mrc/modal/show/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGenerateMrcStatus(idOperation) {
    this.requestName = `/quote/mrc/status-generation/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// Policy Pack insurer //////////////////

  requestInsurerContacts(idOperation) {
    this.requestName = `/quote/policy/insurer/contacts/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSentInsurerPolicyPack(body) {
    this.requestName = `/quote/policy/sent-insurer-policy-pack`;
    let bodyData = body;

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  ///////////// Requests Send Order To Bind //////////////////

  requestBindMessage(idOperation) {
    this.requestName = `/quote/bind/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestBind(idOperation, body, action) {
    this.requestName = `/quote/bind/${idOperation}/${action}`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestIsApprovedBind(idOperation) {
    this.requestName = `/quote/bind/status-approved/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  ///////////// Requests Document Management //////////////////

  requestGetDealDocuments(idOperation, querystring) {
    this.requestName = `/quote/list-documents/${idOperation}` + querystring;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestListDocumentOperations(idOperation) {
    this.requestName = `/quote/list-documents-operations/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// Requests Policy Stamp Management //////////////////

  requestSendPolicyStamp(
    idOperation,
    insurers,
    message,
    isMultipleContacts = false
  ) {
    this.requestName = `/quote/policy-stamp`;
    let body = {
      idOperation,
      insurers,
      message,
      isMultipleContacts,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetPolicyStampStatus(idOperation) {
    this.requestName = `/quote/policy-stamp/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  listStampsContacts(idOperation, idContactDepartment) {
    this.requestName = idContactDepartment
      ? `/quote/policy-stamp/contacts/${idOperation}?idContactDepartment=${idContactDepartment}`
      : `/quote/policy-stamp/contacts/${idOperation}`;

    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestDeletePolicyStampStatus(idOperation) {
    this.requestName = `/quote/policy-stamp/${idOperation}`;
    let body = {};

    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestClonePolicyPack(idOperation) {
    this.requestName = `/quote/policy-stamp/${idOperation}/clone/policy-pack`;
    let body = {};

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  uploadInternalAttachment(body) {
    this.requestName = "/quote/add/attachments/v3/internal";

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestValidatePolicyStampStatus(idOperation) {
    this.requestName = `/quote/policy-stamp/status-stamp/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  reSendPolicyStampInsurer(idOperation, insurer) {
    this.requestName = `/quote/policy-stamp/re-send/${idOperation}`;
    let body = {
      insurer,
    };

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// Requests PaymentList //////////////////

  requestGetPaymentList(queryString) {
    this.requestName = `/payments${queryString}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetPaymentDocs(idOperation) {
    this.requestName = `/payments/documents/${idOperation}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  exportPayments(queryString) {
    this.requestName = `/payments/report/xlsx${queryString}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetPersonsList(queryString) {
    this.requestName = `/person/v2${queryString}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetProductList(queryString) {
    this.requestName = `/management/products${queryString}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetInfoProducts(idPerson, idProduct) {
    this.requestName = `/management/products/${idPerson}/${idProduct}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetProductFormOptions() {
    this.requestName = "/management/products/info/form/options";
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSaveProductInfo(body) {
    this.requestName = `/management/products`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSaveCoverage(body) {
    this.requestName = `/management/coverage/products`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetPersonsInfo(idPerson) {
    this.requestName = `/person/v2/${idPerson}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSavePersonInfo(body) {
    this.requestName = `/person/v2`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetPersonFormOptions(idPerson) {
    this.requestName = `/person/v2/form/options`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSaveContact(body) {
    this.requestName = `/person/v2/contact`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestSetMainContact(idContact) {
    this.requestName = `/person/v2/contact/${idContact}/main-contact`;
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  requestDeleteContact(idContact) {
    this.requestName = `/person/v2/contact/${idContact}`;
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  requestSavePersonRelationship(body) {
    this.requestName = `/person/v2/person-relationship`;
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestDeletePersonRelationship(idPersonRelationship) {
    this.requestName = `/person/v2/person-relationship/${idPersonRelationship}`;
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  requestProcessReportFile(idDocument, readOnly = false) {
    this.requestName = `/payments/import/osnd`;
    let body = { idDocument, readOnly };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestProcessReportFileStatus(idDocument) {
    this.requestName = `/payments/import/osnd/${idDocument}`;
    let body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestPutInstallment(idInstallment, status, osnd, month) {
    this.requestName = `/payments/${idInstallment}`;
    let body = { status, osnd, month };
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestUpdateInstallmentsNotes(idInstallment, notes) {
    this.requestName = `/payments/${idInstallment}/notes`;
    let body = { notes };
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetInstallmentsNotes(idInstallment) {
    this.requestName = `/payments/${idInstallment}/notes`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestPutInstallmentMonths(idInstallment, month) {
    this.requestName = `/payments/${idInstallment}/month`;
    let body = { month };
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetEndorsementsList(queryString) {
    this.requestName = `/endorsements${queryString}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetEndorsementsStatus() {
    this.requestName = `/endorsements/status-endorsements`;
    const body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestUpdateEndorsementEffectiveDate(idOperation, effectiveDate) {
    this.requestName = "/endorsements/effective-date";
    const body = {
      idOperation,
      effectiveDate,
    };

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestGetDocumentMetadata(idOperation) {
    this.requestName = `/endorsements/document-metadata/${idOperation}`;
    const body = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  ///////////// Requests Payment Pack Management //////////////////

  paymentPackHtmlModal(idOperation) {
    this.requestName = `/quote/payment-pack/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestPaymentConfigurationForm(idOperation) {
    this.requestName = `/quote/payment-pack/form/config/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  savePaymentConfigurationForm(idOperation, body, currentPeriod) {
    this.requestName = `/quote/payment-pack/form/config/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      answer: body.answer,
      currentPeriod,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  generatePaymentPack(idOperation, currentPeriod) {
    this.requestName = `/quote/payment-pack`;
    let bodyData = {
      idOperation,
      currentPeriod,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  paymentPackSendApproval(idOperation, policyPackMessage) {
    this.requestName = `/quote/payment-pack/approval/send`;
    let bodyData = {
      idOperation: idOperation,
      policyPackMessage: policyPackMessage,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  paymentSendFramework(idOperation, policyPackMessage) {
    this.requestName = `/quote/payment-pack/framework/send`;
    let bodyData = {
      idOperation: idOperation,
      policyPackMessage: policyPackMessage,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  paymentPackApprove(idOperation, userComments) {
    this.requestName = `/quote/payment-pack/approval/approve`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  paymentPackListDirectors(idOperation) {
    this.requestName = `/quote/payment-pack/approve/list-directors/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementPackRiskMarketChangesSend(idOperation, body) {
    this.requestName = `/endorsement/market-changes/save/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      ...body,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementPackRiskMarketChangesFormData(idOperation) {
    this.requestName = `/endorsement/market-changes/form-data/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementPackRiskMarketDocHtmlModal(idOperation) {
    this.requestName = `/endorsement/market-changes/modal/show/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementPackAdjustmentsCorrectionsSend(idOperation, body) {
    this.requestName = `/endorsement/adjustments-and-corrections/save/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      ...body,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  editEndorsementNotPreAgreedDocument(idOperation, body) {
    this.requestName = `/endorsement/not-pre-agreed/save/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      ...body,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  editEndorsementCancellationDocument(idOperation, body) {
    this.requestName = `/endorsement/cancellation/save/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      ...body,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  editEndorsementOffRiskDocument(idOperation, body) {
    this.requestName = `/endorsement/off-risk/save/${idOperation}`;
    let bodyData = {
      idOperation: idOperation,
      ...body,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSchedulleAssumptionsUploadCorrections(formData) {
    this.requestName = `/quote/schedulle/adjustment-corrections`;

    const options = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Token " + this.fit_auth_token,
        "fit-auth-token": this.fit_auth_token,
      },
    };
    return fetch(this.baseurl + this.requestName, options);
  }

  requestGetSchedulleAssumptionsCorrections(idOperation) {
    this.requestName = `/quote/schedulle/adjustment-corrections/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestDeleteSchedulleAssumptionsCorrections(idOperation, idDocument) {
    this.requestName = `/quote/attachments/v3`;
    let body = {
      idOperation: idOperation,
      idDocument: idDocument,
    };
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  paymentPackReject(idOperation, userComments) {
    this.requestName = `/quote/payment-pack/approval/reject`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestSendPaymantPackToInsurerAndClient(body) {
    this.requestName = `/quote/payment-pack/send/external`;
    let bodyData = body;

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestExternalContacts(idOperation, idOperationRoot) {
    this.requestName = `/quote/payment-pack/contacts/external/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestGeneratePaymentPackStatus(idOperation) {
    this.requestName = `/quote/payment-pack/status-generation/${idOperation}`;
    let body = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  getPersonRoleInformation(operationContext, idPersonRole) {
    let result;
    if (operationContext.add2_response) {
      operationContext.add2_response[0].forEach((element) => {
        if (Number(element.idPersonRole) === Number(idPersonRole)) {
          result = element;
        }
      });
    }
    return result;
  }

  getTextQuestionAnswer(operationContext, idQuestion) {
    let result = "";
    if (
      operationContext.add2_response[3] &&
      operationContext.add2_response[3].ret_value
    ) {
      let questions = [
        operationContext.add2_response[3].ret_value.resultQuestPerson,
        operationContext.add2_response[3].ret_value.resultQuestOperation,
        operationContext.add2_response[3].ret_value.resultQuestRisk,
      ];
      try {
        questions.forEach((element) => {
          element.forEach((element) => {
            if (Number(element.id_question) === Number(idQuestion)) {
              result = element.text_question_answer;
            }
          });
        });
      } catch (err) {
        result = err.message;
      }
    }
    return result;
  }

  getDefaultInstallmentDueDate() {
    let dt = new Date();
    dt.setDate(dt.getDate() + 30);
    let result = "31/05/2020";
    return result;
  }

  getOperationBoleto(operationContext) {
    let result;
    if (
      operationContext.issue_response &&
      operationContext.issue_response instanceof Array &&
      operationContext.issue_response.length === 6
    ) {
      result = operationContext.issue_response[4].payment.bankSlipUrl;
    }

    return result;
  }

  getOperationBoletoConclusion(operationContext) {
    let result;

    try {
      if (
        operationContext.list_issue_action.ret_value &&
        operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT
      ) {
        let metadata = JSON.parse(
          operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT[0]
            .DOCUMENT_METADATA
        );
        result = metadata.payment.bankSlipUrl;
      }
    } catch (err) {
      result = "getOperationBoletoConclusion - ERROR: " + err.message;
    }

    return result;
  }

  getOperationInvoice(operationContext) {
    let result;
    if (
      operationContext.issue_response &&
      operationContext.issue_response instanceof Array &&
      operationContext.issue_response.length === 6
    ) {
      result = operationContext.issue_response[4].payment.invoiceUrl;
    }

    return result;
  }

  getOperationInvoiceConclusion(operationContext) {
    let result;

    try {
      if (
        operationContext.list_issue_action.ret_value &&
        operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT
      ) {
        let metadata = JSON.parse(
          operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT[0]
            .DOCUMENT_METADATA
        );
        result = metadata.payment.invoiceUrl;
      }
    } catch (err) {
      result = "getOperationBoletoConclusion - ERROR: " + err.message;
    }

    return result;
  }

  getOperationModalPolicy(operationContext) {
    const url = this.baseurl + "/quote";
    let result;

    if (
      operationContext.issue_response &&
      operationContext.issue_response instanceof Array &&
      operationContext.issue_response.length === 6
    ) {
      let id_invoice;
      let url_invoice = String(
        operationContext.issue_response[4].payment.invoiceUrl
      ).split("/");
      url_invoice.forEach((element, index) => {
        if (index === url_invoice.length - 1) id_invoice = element;
      });

      let id_operation;
      id_operation = operationContext.add2_response[1].id_operation;

      result =
        url +
        "/modal_policy?id_operation=" +
        id_operation +
        "&id_invoice=" +
        id_invoice +
        "&id_payment=" +
        id_invoice;
    }

    return result;
  }

  getOperationModalPolicyConclusion(operationContext) {
    const url = this.baseurl + "/quote";
    let result;

    try {
      if (
        operationContext.list_issue_action.ret_value &&
        operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT
      ) {
        let metadata = JSON.parse(
          operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT[0]
            .DOCUMENT_METADATA
        );
        let id_operation =
          operationContext.list_issue_action.ret_value.DOCUMENT_PAYMENT[0]
            .ID_OPERATION;
        let id_invoice = String(metadata.payment.id).replace("pay_", "");

        result =
          url +
          "/modal_policy?id_operation=" +
          id_operation +
          "&id_invoice=" +
          id_invoice +
          "&id_payment=" +
          id_invoice;
      }
    } catch (err) {
      result = "getOperationBoletoConclusion - ERROR: " + err.message;
    }

    return result;
  }

  // --------------- ENDORSEMENT OFF RISK -----------------------------------------------------

  requestPolicyNavigation(idOperation) {
    this.requestName = `/operation/v2/next-steps/${idOperation}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestCreateEndorsement(idOperation, endorsmentType) {
    this.requestName = `/endorsement/${endorsmentType}`;
    let body = {
      idOperation: idOperation,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  requestCancelEndorsement(idOperation, cancellationReason) {
    this.requestName = `/endorsements`;
    let body = {
      idOperation: idOperation,
      cancellationReason,
    };
    return this.httpRequestDelete(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  endorsementDocHtmlModal(idOperation, endorsementType) {
    this.requestName = `/endorsement/${endorsementType || "off-risk"
      }/modal/show/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestEndorsementDoc(idOperation, endorsmentType) {
    this.requestName = `/endorsement/${endorsmentType}/save/${idOperation}`;
    let body = {
      idOperation: idOperation,
    };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  endorsementOffRiskFormData(idOperation) {
    this.requestName = `/endorsement/off-risk/form-data/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementOffRiskSendApproval(idOperation, endorsementOffRiskMessage) {
    this.requestName = `/endorsement/off-risk/approval/send`;
    let bodyData = {
      idOperation: idOperation,
      endorsementOffRiskMessage: endorsementOffRiskMessage,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestIsApprovedEndorsementOffRisk(idOperation) {
    this.requestName = `/endorsement/off-risk/status-approved/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  endorsementOffRiskApprove(idOperation, userComments) {
    this.requestName = `/endorsement/off-risk/approval/approve`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementOffRiskReject(idOperation, userComments) {
    this.requestName = `/endorsement/off-risk/approval/reject`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementOffRiskListContact(idOperation) {
    this.requestName = `/endorsement/off-risk/list-contact/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementAdjustmentsFormData(idOperation) {
    this.requestName = `/endorsement/adjustments/form-data/${idOperation}`;
    let bodyData = {};

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementAdjustmentsSendApproval(idOperation, endorsementOffRiskMessage) {
    this.requestName = `/endorsement/adjustments/approval/send`;
    let bodyData = {
      idOperation: idOperation,
      endorsementOffRiskMessage: endorsementOffRiskMessage,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  requestIsApprovedEndorsementAdjustments(idOperation) {
    this.requestName = `/endorsement/adjustments/status-approved/${idOperation}`;
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  endorsementAdjustmentsApprove(idOperation, userComments) {
    this.requestName = `/endorsement/adjustments/approval/approve`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  endorsementAdjustmentsReject(idOperation, userComments) {
    this.requestName = `/endorsement/adjustments/approval/reject`;
    let bodyData = {
      idOperation: idOperation,
      userComments: userComments,
    };

    return this.httpRequestPost(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  resetOperationState(idOperation, restart, application) {
    this.requestName = `/operation/v2/restart-state/${idOperation}`;
    let body = { idOperation: idOperation, restart, application };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  juntoUpdateQuote(idOperation, updateDraft, updateQuote) {
    this.requestName = `/junto-garantia/calculate/${idOperation}?operation=1${updateDraft ? `&updateDraft=${updateDraft}` : ""}${updateQuote ? `&updateQuote=${updateQuote}` : ""}`;
    return this.httpRequestPut(
      this.baseurl + this.requestName,
      {},
      this.fit_auth_token
    );
  }

  requestOperationInfo(idOperation, params) {
    this.requestName = params
      ? `/operation/v2/info/${idOperation}` + params
      : `/operation/v2/info/${idOperation}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestOperationNotes(idOperation, idQuestion) {
    this.requestName = `/operation/v2/notes/${idOperation}?idQuestion=${idQuestion}`;

    return this.httpRequestGet(
      this.baseurl + this.requestName,
      null,
      this.fit_auth_token
    );
  }

  requestOperationNotesUpdate(idOperation, idQuestion, comment) {
    this.requestName = `/operation/v2/notes/${idOperation}`;

    const body = {
      comment,
      idQuestion
    };

    return this.httpRequestPut(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  createMarketChangeQuotation(idOperation) {
    this.requestName = `/endorsement/market-changes/quotation`;
    let body = { idOperation };
    return this.httpRequestPost(
      this.baseurl + this.requestName,
      body,
      this.fit_auth_token
    );
  }

  qlikToken() {
    this.requestName = `/data/qlik/auth`;
    let bodyData = {};
    return this.httpRequestGet(
      this.baseurl + this.requestName,
      bodyData,
      this.fit_auth_token
    );
  }

  // ==========================================================================================
  // BASE HTTP FUNCTIONS
  // ==========================================================================================
  httpRequestPost(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: "POST",
      headers: this.getRequestHeaders(token),
      body: JSON.stringify(requestBody),
    });
  }

  httpRequestPut(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: "PUT",
      headers: this.getRequestHeaders(token),
      body: requestBody ? JSON.stringify(requestBody) : null,
    });
  }

  httpRequestGet(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: "GET",
      headers: this.getRequestHeaders(token),
    });
  }

  httpRequestDelete(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: "DELETE",
      headers: this.getRequestHeaders(token),
      body: JSON.stringify(requestBody),
    });
  }

  setAuthToken(value) {
    this.fit_auth_token = value;
  }

  getRequestHeaders(token) {
    let result;
    result = {
      "Content-Type": "application/json",
      Authorization: "Token " + token,
      "fit-auth-token": token,
    };
    return result;
  }
}

export default FitinsurAPI;
